import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API } from '@const'
import * as utils from '@utils'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import Divider from '@material-ui/core/Divider'

import { store } from '@redux/store'
import MaterialTable from 'material-table'
import { SaveAlt } from '@material-ui/icons'
import { Button, FormControl, TextField, Select, MenuItem, FormLabel, Grid } from '@material-ui/core'
import { PfSubPfSelect } from '@select'
import { addToast } from '../../utils/toast'
import { TreeSelect } from 'antd'

const initialState = {
    title: '',
    dialogOpen: false,
    pf_id: '',
    data: {},
    assignData: {},
    rankinputs: {},
    isTableLoading: false,
    openKey: '',
    pf_sub_pf_list: [],
    pfSubTree: [],
    status: 'active',
    name: '',
    id: null,
    openRoute: '',
    pageSize: 10
}

class EditPlatformRecommendDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'EditPlatformRecommendDialog')
        }
        this.state = initialState
    }

    columns = [
        {
            field: 'rankings',
            title: utils.t('rankings', 'GameRecommendDialog'),
            render: (rowData) => {
                return <div>{rowData.rankings}</div>
            },
        },
        {
            field: 'chineseName',
            title: utils.t('chineseName', 'GameRecommendDialog'),
            render: (rowData) => {
                return <div>{rowData.chineseName}</div>
            },
        },
        {
            field: 'englishName',
            title: utils.t('englishName', 'GameRecommendDialog'),
            render: (rowData) => {
                return <div>{rowData.englishName}</div>
            },
        },
        {
            field: '',
            title: utils.t('action', 'GameRecommendDialog'),
            render: (rowData) => {
                return (
                    <div>
                       <input
                            value={this.state.rankinputs[rowData.game_code] || ''}
                            onChange={(event) => {
                                const value = event.target.value.replace(/[^\d]/g, '')
                                if (String(value).charAt(0) === '0') return
                                this.setState(
                                    {
                                        rankinputs: {
                                            ...this.state.rankinputs,
                                            [rowData.game_code]: value,
                                        },
                                    }
                                )
                            }}
                            className={this.props.classes.sortInput}
                        />
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                if (this.state.rankinputs[rowData.game_code]) {
                                    const newRank = Number(this.state.rankinputs[rowData.game_code])
                                    if (newRank === 0) return
                                    if (newRank > this.state.data.rank_info.length) {
                                        addToast(utils.t('sortQuantityOverload', 'GameRecommendDialog'), 'error')
                                        return
                                    }
                                    this.sortRank(rowData.game_code, newRank)
                                    this.setState({ rankinputs: {} })
                                }
                            }}
                            className={this.props.classes.sortButton}>
                            {this.t('confirm')}
                        </Button>
                    </div>
                )
            },
            cellStyle: {
                width: '195px',
            },
        },
    ]

    sortRank(gameCode, newRank) {
        const currentObject = this.state.data.rank_info.find((item) => item.game_code === gameCode)
        const cloneData = JSON.parse(JSON.stringify(this.state.data.rank_info))
        const currentRank = currentObject.rank
        if (currentObject) {
            if (currentRank === newRank || newRank === 0) return
            cloneData.forEach((item) => {
                const isCurrentGame_code = item.game_code === gameCode // 是否為要變更排名的 item
                if (isCurrentGame_code) {
                    item.rank = newRank
                    return
                }
                if (item.rank > currentRank && item.rank <= newRank) {
                    item.rank--
                }
                if (item.rank < currentRank && item.rank >= newRank) {
                    item.rank++
                }
            })

            cloneData.sort((a, b) => a.rank - b.rank)
            this.formatExportKey({ ...this.state.data, rank_info: cloneData })
            this.setState({ rankinputs: {}, data: { ...this.state.data, rank_info: cloneData } })
        }
    }

    setRankInfo(data) {
        this.setState({ data, assignData: JSON.parse(JSON.stringify(data.rank_info)) })
    }

    formatExportKey(data) {
        data.rank_info.forEach((item) => {
            const game = store.getState().dataService.gameList.find((gameListitem) => gameListitem.game_code === item.game_code)
            item.rankings = item.rank
            item.chineseName = game.name_chs
            item.englishName = game.name_enu
        })
        return data.rank_info
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    OpenDialog(inputs) {
        const { title, rowData, openRoute } = inputs
        const { ranks, pf_id, id, pf_sub_pf_list, name, status } = rowData
        const statusData = { 
            1: 'active' , 
            2: 'close', 
            3: 'noParticipate' 
        }
        this.setState(
            {
                dialogOpen: true,
                status: statusData[status],
                title,
                pf_id,
                id,
                pf_sub_pf_list,
                name,
                openRoute,
            },
            () => {
                this.setSelect()
            }
        )
        const data = { rank_info: ranks }
        data.rank_info = this.formatExportKey(data)
        this.setRankInfo(data)
    }

    async setSelect() {
        await this.handlePfTreeData()
        this.platformPfSubPfSelect.setState({
            pfId: this.state.pf_id,
        })
    }

    closeDialog() {
        this.setState(initialState)
    }

    async confirm() {
        await this.editPlatformRecommend()
    }

    verifyData() {
        const { pf_id, name, pf_sub_pf_list } = this.state

        const verifyRule = {
            noNameEnter: name.length === 0,
            noCustomCurrencySelect: pf_id.length === 0,
            noCustomPlatformSelect: pf_sub_pf_list.length === 0
        }
        
        const errorList = []
        Object.entries(verifyRule).forEach(([key, item]) => {
            if (item) {
                addToast(utils.t(key, 'GameRecommendDialog'), 'error')
                errorList.push(key)
            }
        })
        return errorList.length === 0 ? true : false
    }

    async editPlatformRecommend() {
        const statusData = { 'active': 1, 'close': 2, 'noParticipate': 3 }
        const { pf_id, name, pf_sub_pf_list, data, status, id } = this.state
        const { rank_info: ranks } = data
        const API_PATH = this.state.openRoute === 'new-game-recommend-page' ? API.PLATFORM_RECOMMENDATIONS_LATEST : API.PLATFORM_RECOMMENDATIONS_TOP
        
        if (this.verifyData()) {
            utils.apiRequest(
                'patch',
                `${API_PATH}/${id}`,
                { pf_id, name, pf_sub_pf_list, ranks, status: statusData[status] },
                (_data) => {
                    this.closeDialog()
                    if (this.props.confirmCallback) {
                        this.props.confirmCallback()
                    }
                },
                (_err) => {},
                true
            )
        }
    }

    handlePfTreeData = async () => {
        this.setState({
            pfSubTree: utils.generatePfTreeData().filter((item) => item.key === this.state.pf_id),
        })
    }

    render() {
        return (
            <Dialog
                fullWidth
                maxWidth="md"
                open={this.state.dialogOpen}
                onClose={() => {
                    this.closeDialog()
                }}>
                <DialogTitle>{this.state.title}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item className={this.props.classes.alignCenter}>
                            <FormControl className={this.props.classes.formControl}>
                                <FormLabel className={this.props.classes.shrink}>{this.t('name')}</FormLabel>
                                <TextField
                                    value={this.state.name}
                                    onChange={(event) => {
                                        this.setState({
                                            name: event.target.value,
                                        })
                                    }}
                                    variant="standard"
                                    placeholder={this.t('eventNameValid')}
                                    type="text"
                                />
                            </FormControl>
                        </Grid>
                        <Grid item className={this.props.classes.alignCenter}>
                            <PfSubPfSelect
                                onRef={(ref) => (this.platformPfSubPfSelect = ref)}
                                options={{
                                    pfChangeCallback: () => {
                                        this.setState({ pf_id: this.platformPfSubPfSelect.state.pfId }, async () => {
                                            this.setSelect()
                                        })
                                    },
                                    disabled: true,
                                    hideAutocomplete: true,
                                    hideAllPlatform: true,
                                }}
                            />
                        </Grid>
                        <Grid item className={this.props.classes.alignCenter}>
                            <FormControl className={this.props.classes.formControl}>
                                <FormLabel style={{ marginBottom: '2px' }} className={this.props.classes.shrink}>
                                    {this.t('pfSubPf')}
                                </FormLabel>
                                <TreeSelect
                                    treeData={this.state.pfSubTree}
                                    value={this.state.pf_sub_pf_list}
                                    onChange={(value) => {
                                        this.setState({
                                            pf_sub_pf_list: value,
                                        })
                                    }}
                                    maxTagCount={1}
                                    treeCheckable={true}
                                    showSearch={true}
                                    listHeight={64}
                                    showCheckedStrategy={TreeSelect.SHOW_CHILD}
                                    searchPlaceholder={this.t('pleaseSelect')}
                                    dropdownStyle={{ zIndex: 3000 }}
                                    getPopupContainer={()=>{
                                        return document.getElementById('treeSelectBox')
                                    }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item className={this.props.classes.alignCenter}>
                            <FormControl className={this.props.classes.formControl} style={{ marginBottom: '-8px' }}>
                                <FormLabel className={this.props.classes.shrink}>{this.t('isActive')}</FormLabel>
                                <Select
                                    value={this.state.status}
                                    onChange={(event) => {
                                        this.setState({
                                            status: event.target.value,
                                        })
                                    }}
                                    style={{ marginTop: '0' }}>
                                    {['active', 'close', 'noParticipate'].map((item) => (
                                        <MenuItem value={item} key={item}>
                                            {this.t(item)}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <MaterialTable
                        isLoading={this.state.isTableLoading}
                        title={''}
                        components={{
                            Toolbar: () => {
                                return <></>
                            },
                        }}
                        icons={{ Export: SaveAlt }}
                        ownerName="EditGameRecommendDialog"
                        data={this.state.data.rank_info}
                        columns={this.columns}
                        options={{
                            exportButton: false,
                            export: false,
                            tableLayout: 'fixed',
                            pageSize: this.state.pageSize,
                            pageSizeOptions: [10, 30, 50, 100],
                            search: false,
                            sorting: false,
                        }}
                        onRef={(ref) => (this.table = ref)}
                        onChangeRowsPerPage={(pageSize) => {
                            this.setState({ pageSize })
                        }}
                    />
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button variant="contained" onClick={() => this.confirm()} color="primary">
                        {this.t('confirm')}
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => {
                            this.closeDialog()
                        }}
                        color="primary">
                        {this.t('cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const styles = (theme) => {
    return {
        rerankBtn: {
            marginLeft: '10px',
        },
        sortInput: {
            width: '80px',
            height: '30px',
        },
        sortButton: {
            height: '30px',
            marginLeft: '15px',
            marginBottom: '5px',
        },
        refreshBtn: {
            marginTop: '19px',
            marginBottom: '10px',
        },
        formControl: {
            marginTop: theme.spacing(1),
            marginBottom: '25px',
            width: '200px',
        },
        shrink: {
            transform: 'translate(0, 1.5px) scale(0.75)',
            transformOrigin: 'top left',
            marginBottom: '0',
        },
    }
}

EditPlatformRecommendDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    confirmCallback: PropTypes.func,
}

export default hoc(styles)(EditPlatformRecommendDialog)
